// Mirrors a dashboard panel frame's filter params into the page URL, so
// /dashboard stays the canonical, bookmarkable address for every panel's state
// (a pill click navigates only the frame; nothing else touches the URL).
//
// Sits on the element wrapping the panel frames; turbo:frame-load bubbles, so
// one action covers them all:
//
// <section data-controller="dashboard-url-sync"
//          data-action="turbo:frame-load->dashboard-url-sync#sync">
//   <turbo-frame id="dashboard_activity" data-url-namespace="activity" ...>
//
// Each panel's endpoint takes its params under the same namespaced key the
// page URL owns (activity[...]), so the frame's query string can be adopted
// verbatim: drop the page URL's params under the frame's namespace, then
// append the frame's own. replaceState rather than pushState keeps history
// management Turbo's alone — back/forward moves between pages, not filters —
// which is also why Turbo's own history.state is passed back through.

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  sync (event) {
    const namespace = event.target.dataset.urlNamespace
    if (!namespace) return

    const url = new URL(window.location)
    const src = new URL(event.target.src, window.location)
    for (const key of [...url.searchParams.keys()]) {
      if (key === namespace || key.startsWith(`${namespace}[`)) url.searchParams.delete(key)
    }
    src.searchParams.forEach((value, key) => url.searchParams.append(key, value))

    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url)
  }
}
